import {
  ProductReviewManyResponseDTO,
  ProductReviewResponseDTO,
  ProductReviewSingleResponseDTO
} from "@shared/DTO/ProductReviewResponseDTO";
import {
  ProductNameResponseItemDTO,
  ProductNamesResponseDTO,
  ProductNamesQueryDTO,
  ProductResponseDTO,
  ProductSingleResponseDTO,
  ProductSlimManyResponseDTO,
  ProductSlimResponseDTO,
  ProductSlimQueryOptions
} from "@shared/DTO";
import {HttpClient} from "@/scripts/core/http/httpClient";
import {ResourceLoader} from "@/scripts/core/http/resourceLoader";
import {ProductReviewRequestDTO} from "@shared/DTO/ProductReviewRequestDTO";
import {buildProductNamesKey} from "./productNamesKey";

class ProductApiService {

  private httpClient = new HttpClient(
    {
      baseUrl: (import.meta as any).env?.VITE_API_BASE_NODE
    }
  );

  // Chiamate di getProduct e getProductByWpId
  private productLoader = new ResourceLoader<string, ProductResponseDTO>(
    {
      // params può essere il productId (ex: "642f1b2e4f1a2567c8e4d3a1") oppure una di parametri (ex: "wp/333")
      fetcher: async (params) => {
        const url = `/products/${params}`;
        const res = await this.httpClient
          .get<ProductSingleResponseDTO>(url);
        return res.data.product;
      }
    }
  );

  // Chiamata productNames
  private productNamesLoader = new ResourceLoader<string, ProductNameResponseItemDTO[]>(
    {
      fetcher: async (key) => {
        const url = `/products/${key}`;
        const res = await this.httpClient
          .get<ProductNamesResponseDTO>(url);
        return res.data.products;
      }
    }
  );

  // Chiamata productSlim
  private productSlimLoader = new ResourceLoader<{ source: string } & ProductSlimQueryOptions, ProductSlimResponseDTO[]>(
    {
      fetcher: async ({ source, include }) => {
        const url = `/products/slim?source=${encodeURIComponent(source)}${include ? `&include=${include}` : ""}`;
        const res = await this.httpClient
          .get<ProductSlimManyResponseDTO>(url);
        return res.data.products;
      }
    }
  );

  private productReviewsLoader = new ResourceLoader<string, ProductReviewResponseDTO[]>(
    {
      fetcher: async (productId) => {
        const url = `/products/${productId}/reviews`;
        const res = await this.httpClient
          .get<ProductReviewManyResponseDTO>(url);
        return res.data.reviews;
      }
    }
  );

  public getProductNames(filters: ProductNamesQueryDTO = {}) {
    return this.productNamesLoader.get(buildProductNamesKey(filters), {force: false});
  }

  public getProduct(productId: string)  {
    return this.productLoader.get(productId, {force: false});
  }

  public getProductSlim(source: string, options: ProductSlimQueryOptions = {}) {
    return this.productSlimLoader.get({ source, ...(options.include ? { include: options.include } : {}) }, {force: false});
  }
  
  public getReviews(productId: string) {
    return this.productReviewsLoader.get(productId, {force: false});
  }

  public submitReview(
    productId: string,
    review: ProductReviewRequestDTO
  ) {
    const url = `/products/${productId}/reviews`;
    return this.httpClient.post<ProductReviewSingleResponseDTO>(url, { ...review });
  }

}

export default new ProductApiService();
